import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from 'src/store/store';
import { PersistGate } from 'redux-persist/integration/react';
import ReactDOM from 'react-dom';
import { ConfirmModal } from 'src/providers/Confirm/ConfirmModal';
import ConfirmContextProvider from 'src/providers/Confirm/ConfirmContextProvider';
import moment from 'moment-timezone';
import { history } from './utils/history';
import Routes from './routes';
import './styles/index.css';

import 'react-toastify/dist/ReactToastify.css';
import { notifyInfo } from './utils/notification';
import AppErrorBoundary from './components/AppErrorBoundary';

window.addEventListener('error', (event) => {
  // This is intentionally visible in production to diagnose otherwise blank pages.
  // eslint-disable-next-line no-console
  console.error('[TrackIn window error]', {
    message: event.message,
    stack: event.error?.stack,
    source: event.filename,
    line: event.lineno,
    column: event.colno,
    path: window.location.href,
  });
});

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason instanceof Error
    ? { message: event.reason.message, stack: event.reason.stack }
    : event.reason;
  // This is intentionally visible in production to diagnose otherwise blank pages.
  // eslint-disable-next-line no-console
  console.error('[TrackIn unhandled promise rejection]', {
    reason,
    path: window.location.href,
  });
});

const App = () => {
  // Setting default timezone to Europe/London
  // moment.tz.setDefault('Europe/London');
  moment.tz.setDefault();

  // When the app is loaded, checks if the version of the app is different from the one stored in the local storage.
  // If it is different, the user is redirected to the login page.
  if (localStorage.getItem('version') !== process.env.REACT_APP_VERSION) {
    notifyInfo('A new version of the app is available. Please, log in again.');
    persistor.purge().then(() => {
      localStorage.clear();
      localStorage.setItem('version', process.env.REACT_APP_VERSION!);
      history.push('/login');
    });
  }

  return (
    <React.StrictMode>
      <Router history={history}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ConfirmContextProvider>
              <ConfirmModal />

              <ToastContainer />
              <Routes />
            </ConfirmContextProvider>
          </PersistGate>
        </Provider>
      </Router>
    </React.StrictMode>
  );
};

ReactDOM.render(
  <AppErrorBoundary>
    <App />
  </AppErrorBoundary>,
  document.getElementById('root'),
);
